import React from "react";
import Modal from "react-bootstrap/Modal";
import Folder from "./Folder";
import { useSelector } from "react-redux";

const ModalCopyScenario = (props) => {
  const destinationFolderId = useSelector((state) => state.destinationFolderId);
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">{props.title}</h4>
          {props?.tree?.scenariosTree?.map((folder) => (
            <Folder
              id={folder.id}
              name={folder.name}
              key={folder.id}
              folders={folder?.folders}
            />
          ))}
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
          {props?.isActiveCopyScenarioButton && destinationFolderId !== null && (
            <button
              type="button"
              onClick={props.handle}
              className="large-button green"
            >
              COPY SCENARIO
            </button>
          )}
          {props?.tree?.scenariosTree?.length === 0 && (
            <button
              type="button"
              onClick={props.handleCreateNewFolder}
              className="large-button green"
            >
              CREATE NEW FOLDER
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalCopyScenario;
